import React, { useState, useRef, useEffect } from "react";
import { toast } from "react-toastify";
import { httpReauest } from "../../utils/httpRequest";

const WheelOfFortuneLayout = ({ getData, data }) => {
  const [isSpinning, setIsSpinning] = useState(false);
  const [winner, setWinner] = useState(null);
  const wheelRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // فقط یک‌بار در هنگام لود نمایش داده شود
    setShowPopup(true);
    const timer = setTimeout(() => {
      setShowPopup(false);
    }, 3000); // 3 ثانیه

    return () => clearTimeout(timer);
  }, []);

  // لیست جوایز با شانس و زاویه مربوطه
  const prizes = [
    { value: "50", angle: 0, weight: 55 }, // 30% شانس
    { value: "1000", angle: 36, weight: 6 }, // 5% شانس
    { value: "80%", angle: 72, weight: 0.33 }, // 10% شانس
    { value: "200", angle: 108, weight: 8 }, // 20% شانس
    { value: "good luck next time", angle: 144, weight: 6 }, // 15% شانس
    { value: "100", angle: 180, weight: 10 }, // 10% شانس
    { value: "2 extra spins", angle: 216, weight: 6 }, // 5% شانس
    { value: "nft", angle: 252, weight: 0.33 }, // 2% شانس
    { value: "500", angle: 288, weight: 6 }, // 2% شانس
    { value: "next level", angle: 324, weight: 0.33 }, // 1% شانس
  ];

  const pointerAngle = 90;

  // تابع انتخاب تصادفی با وزن
  const getRandomPrizeIndex = () => {
    const totalWeight = prizes.reduce((sum, prize) => sum + prize.weight, 0);
    let random = Math.random() * totalWeight;

    for (let i = 0; i < prizes.length; i++) {
      if (random < prizes[i].weight) return i;
      random -= prizes[i].weight;
    }

    return prizes.length - 1;
  };

  const spinWheel = () => {
    if (isSpinning) return;

    setIsSpinning(true);
    setWinner(null);

    const spins = 5;
    const winnerIndex = getRandomPrizeIndex(); // استفاده از تابع وزندار

    const targetAngle = prizes[winnerIndex].angle;
    const totalRotation = 360 * spins + targetAngle + (360 - pointerAngle);

    wheelRef.current.style.transition = "none";
    wheelRef.current.style.transform = "rotate(0deg)";

    setTimeout(() => {
      wheelRef.current.style.transition =
        "transform 5s cubic-bezier(0.17, 0.67, 0.21, 0.99)";
      wheelRef.current.style.transform = `rotate(${-totalRotation}deg)`;
    }, 10);

    setTimeout(() => {
      setIsSpinning(false);
      setWinner(prizes[winnerIndex]);
      showPrize(prizes[winnerIndex].value);
    }, 5100);
  };

  const showPrize = async (prize) => {
    if (prize === "good luck next time") {
      toast.info(prize);
      await handleSubmit({ prize });
    } else if (prize.match(/^\d+$/)) {
      await handleSubmit({ prize });
      toast.success(`You won ${prize} points!`);
    } else {
      await handleSubmit({ prize });
      toast.info(`You won: ${prize}!`);
    }
  };

  async function handleSubmit({ prize }) {
    const user = JSON.parse(localStorage.getItem("user"));
    await httpReauest(
      "POST",
      "/user/wheel",
      { prize },
      { "x-access-token": user?.token }
    )
      .then(async (res) => {
        await getData();
      })
      .catch((data) => {
        toast.error(data?.response?.data?.message);
      });
  }

  return (
    <div className="relative max-w-[400px] max-h-[400px] lg:max-w-[600px] lg:max-h-[600px] mx-auto mt-4">
      <span className="bg-yellow-200 text-[14px] lg:text-[16px] p-2 rounded-lg border border-orange-600 text-orange-600 font-bold">
        Remaining spin: {data?.spins}
      </span>
      <div
        className={`${
          data?.spins < 1 && "opacity-50"
        } relative w-full h-full mt-4`}
      >
        <div className={`${showPopup ? "opacity-100 scale-105" : "opacity-0 scale-90 -z-10"} duration-500 absolute top-[40%] -translate-y-1/2 left-1/2 -translate-x-1/2 z-30 flex flex-col items-center`}>
          <div className="bg-blue-500 text-white font-bold text-[14px] lg:text-[16px] px-4 py-2 rounded shadow-lg">
            Press the button
          </div>
          <div className="w-0 h-0 border-l-[12px] border-r-[12px] border-t-[12px] border-l-transparent border-r-transparent border-t-blue-500" />
        </div>

        <img
          ref={wheelRef}
          src="/Spin-Wheel2.png"
          alt="Wheel of Fortune"
          className="w-full h-full rounded-full object-cover"
          style={{ transform: "rotate(0deg)" }}
        />

        <button
          className={`absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 
                    w-16 lg:w-20 h-16 lg:h-20 rounded-full flex items-center justify-center 
                    font-bold shadow-lg z-10`}
          onClick={spinWheel}
          disabled={data?.spins < 1 || isSpinning}
        ></button>

        <div className="absolute top-[33%] -right-8 rotate-[70deg] transform -translate-y-1/2 z-20">
          <img
            src="/Pointer-Spin.png"
            className="w-24 sm:w-28 h-24 sm:h-28 lg:h-32 lg:w-32"
            alt="Pointer"
          />
        </div>
      </div>
    </div>
  );
};

export default WheelOfFortuneLayout;
